import React from 'react'
import { useCalcOffsetPagination } from '@/shared/hooks/useCalcOffsetPagination'
import BootstrapPagination from 'react-bootstrap/Pagination'

// pageQuantity             - количество страниц
// currentPage              - текущая страница пагинации
// offset                   - количество показываемых кнопок рядом с текущей страницей пагинации
// handlePaginationButton   - обработчик клика на странцу пагинации
// limitReviews             - условие, при котором показывается кнопка "показать ещё"
// handleShowMore           - обработчик событий при клике на кнопку "показать ещё"

export function PaginationBtns({
    pageQuantity,
    currentPage,
    offset,
    handlePaginationButton,
    limitReviews,
    handleShowMore,
}) {
    const paginationCalc = useCalcOffsetPagination(
        pageQuantity,
        currentPage,
        offset
    ) // функция, которая вычисляет кнопку пагинации

    const pageButtons = []
    for (let i = paginationCalc.min; i <= paginationCalc.max; i++) {
        pageButtons.push(
            <BootstrapPagination.Item
                key={i + 'pagination'}
                active={i === currentPage}
                onClick={() => handlePaginationButton(i)}
            >
                {i}
            </BootstrapPagination.Item>
        )
    }

    return (
        <div className="PaginationCatalog">
            {limitReviews ? (
                <button className="btn" onClick={handleShowMore} variant="dark">
                    Показать ещё
                </button>
            ) : (
                ''
            )}
            <BootstrapPagination>
                {paginationCalc.position !== 'left' &&
                    pageQuantity > offset * 2 + 1 && (
                        <>
                            <BootstrapPagination.First
                                onClick={() => handlePaginationButton(1)}
                            />
                            <BootstrapPagination.Prev
                                onClick={() =>
                                    handlePaginationButton(currentPage - 1)
                                }
                            />
                            <BootstrapPagination.Ellipsis />
                        </>
                    )}
                {pageButtons}
                {paginationCalc.position !== 'right' &&
                    pageQuantity > offset * 2 + 1 && (
                        <>
                            <BootstrapPagination.Ellipsis />
                            <BootstrapPagination.Next
                                onClick={() =>
                                    handlePaginationButton(currentPage + 1)
                                }
                            />
                            <BootstrapPagination.Last
                                onClick={() =>
                                    handlePaginationButton(pageQuantity)
                                }
                            />
                        </>
                    )}
            </BootstrapPagination>
        </div>
    )
}
